// src/analytics.js
// Usage statistics (Firebase / Google Analytics) are only collected after the person said yes. The answer is kept in
// this browser; the banner (components/ConsentBanner.jsx) asks, and the footer lets them change their mind.
const KEY = 'tournamental.analyticsConsent'; // 'granted' | 'denied' | absent: not asked yet
const listeners = new Set();
const reviewListeners = new Set(); // told to show the banner again, without touching the saved choice
let analytics = null; // the Firebase Analytics instance, once it has been started

export function consentChoice() {
    try {
        const value = window.localStorage.getItem(KEY);
        return value === 'granted' || value === 'denied' ? value : null;
    } catch (error) {
        return null;
    }
}

export function subscribeToConsent(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function subscribeToConsentReview(listener) {
    reviewListeners.add(listener);
    return () => reviewListeners.delete(listener);
}

// The footer's "Privacy settings": shows the banner again over whatever was chosen before, so it can be seen and
// changed. Unlike `setConsent(null)`, it does not erase the saved choice by itself.
export function reviewConsent() {
    reviewListeners.forEach((listener) => listener());
}

async function apply(choice) {
    if (choice === 'granted') {
        const { app } = await import('./firebase');
        const module = await import('firebase/analytics');
        if (!analytics) analytics = module.getAnalytics(app);
        module.setAnalyticsCollectionEnabled(analytics, true);
    } else if (analytics) {
        const module = await import('firebase/analytics');
        module.setAnalyticsCollectionEnabled(analytics, false);
    }
}

// Records the answer and acts on it now.
export async function setConsent(choice) {
    try {
        if (choice === null) window.localStorage.removeItem(KEY);
        else window.localStorage.setItem(KEY, choice);
    } catch (error) {
        // not remembered: asked again next time
    }
    listeners.forEach((listener) => listener(choice));
    try {
        await apply(choice);
    } catch (error) {
        console.error('Could not change the analytics setting:', error);
    }
}

// At the start of the app: collection only starts if it was allowed earlier.
export function startAnalyticsIfAllowed() {
    if (consentChoice() === 'granted') apply('granted').catch(() => {});
}
